<template>
  <CSidebar
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img class="icon" alt="Aeru_logo" src="../assets/icons/logo.png" width="200">
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="filteredNav"/>
  </CSidebar>
</template>

<script>
import { mapGetters } from 'vuex';
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
    isPermitted() {
      return this.role == 'super_admin'
    },
    isMemberNotPermitted() {
      return this.role == 'member'
    },
    ...mapGetters({
      role:'GetRole',
    }),
    filteredNav() {
      const role = this.role
      const filterByRole = (items) => {
        return items
          .map(item => {
            if (item._name === 'CSidebarNavTitle' && item.role && !item.role.includes(role)) {
              return null
            }
        if (item._children) {
          const filteredChildren = filterByRole(item._children)
          if (filteredChildren.length > 0) {
            return { ...item, _children: filteredChildren }
          }
          return null
        }
        if (!item.role || item.role.includes(role)) {
          return item
        }
        return null
      })
      .filter(Boolean)
      }
      return filterByRole(this.$options.nav)
    }
  }
}
</script>
